// Boolean HTML attributes are on whenever they are present, including multiple="undefined".
export function isOmittedAttrValue(theVal) {
    return (
        theVal == null ||
        theVal === '' ||
        theVal === false ||
        theVal === 'false' ||
        theVal === 'undefined' ||
        theVal === 'null'
    )
}

// Saved forms picked up allowMulti "undefined" from an editor onChange bug.
export function normalizeLoadedAllowMulti(value) {
    if (value === 'undefined' || value === 'null' || value == null) return ''
    return value
}
